import React from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { useRequest } from "../hooks/useRequest";
import { getGamesUrl } from "../config/api";
import { Game } from "../types/models";
import { PaginatedResponse } from "../types/api";
import GameListItem from "../Common/GameListItem";
import { adminGameUrl } from "./adminGameLinks";

interface UpcomingGamesProps {
  seasonId: number;
  limit?: number;
}

function ListLoadingView() {
  return (
    <Row className="justify-content-md-center">
      <Col md="auto">
        <Spinner animation="grow" /> Loading...
      </Col>
    </Row>
  );
}

function UpcomingGames({ seasonId, limit = 5 }: UpcomingGamesProps) {
  const auth = useAuth();

  const { data: gamesResponse, error: gamesError } = useRequest<
    PaginatedResponse<Game>
  >(getGamesUrl(seasonId), auth.token);

  if (gamesError) {
    return (
      <Alert variant="danger">Error loading games: {gamesError.message}</Alert>
    );
  }

  if (!gamesResponse) {
    return <ListLoadingView />;
  }

  const now = new Date();

  // Soonest first, so the next game to be played is at the top.
  const upcomingGames = gamesResponse.data
    .filter((game) => new Date(game.date) >= now)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .slice(0, limit);

  if (upcomingGames.length === 0) {
    return <p className="text-muted">No upcoming games scheduled.</p>;
  }

  return (
    <div>
      {upcomingGames.map((game) => (
        <GameListItem
          key={game.id}
          game={game}
          to={adminGameUrl(seasonId, game.id)}
        />
      ))}
    </div>
  );
}

export default UpcomingGames;
